(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[811],{

/***/ 29689:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/favorites",
      function () {
        return __webpack_require__(69197);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 69197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FavoritesPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./src/components/account/styles.ts
var styles = __webpack_require__(99736);
// EXTERNAL MODULE: ./src/components/account/uielements/index.tsx + 1 modules
var uielements = __webpack_require__(9671);
// EXTERNAL MODULE: ./src/components/cmsConfig/stringAccessor/index.tsx
var stringAccessor = __webpack_require__(90836);
// EXTERNAL MODULE: ./src/components/featureAccessor/index.tsx
var featureAccessor = __webpack_require__(88917);
// EXTERNAL MODULE: ./src/components/locations/card/index.tsx + 10 modules
var card = __webpack_require__(93483);
// EXTERNAL MODULE: ./src/components/uielements/favoriteCard/styles.tsx
var favoriteCard_styles = __webpack_require__(73231);
// EXTERNAL MODULE: ./src/constants/cssClassNames.ts
var cssClassNames = __webpack_require__(5733);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/redux/global/reducer.ts
var reducer = __webpack_require__(83626);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/redux/me/reducer.ts
var me_reducer = __webpack_require__(17426);
;// CONCATENATED MODULE: ./src/components/account/favorites/favoriteLocations/index.tsx














var FavoriteLocations = function() {
    var favoriteLocations = (0,es.useSelector)(me_reducer/* meSliceSelector */.G).favoriteLocations;
    var featureBag = (0,es.useSelector)(reducer/* globalSliceSelector */.lp);
    var isFavoriteLocationsEnabled = // @ts-ignore `ACCOUNT__FAVORITE_LOCATIONS_ENABLED` can't index `featureBag`.
    featureBag[features/* FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */.y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED];
    var dispatch = (0,es.useDispatch)();
    (0,react.useEffect)(function() {
        isFavoriteLocationsEnabled && dispatch(actions/* default.fetchMeFavoriteLocations */.Z.fetchMeFavoriteLocations());
    }, []);
    var alphabeticalFavoriteLocations = favoriteLocations && favoriteLocations.sort(function(locationA, locationB) {
        return locationA.label > locationB.label ? 1 : -1;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(featureAccessor/* FeatureAccessor */.R, {
        featureFlag: features/* FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */.y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLoyaltyContainer */.t9, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(favoriteCard_styles/* StyledFavoritesFlexContainer */.wo, {
                className: cssClassNames/* CSS_CLASSES.LOYALTY.PAGE_HEADER */.Y.LOYALTY.PAGE_HEADER,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h2",
                        accessor: "favorites.locations_header",
                        html: true
                    }),
                    alphabeticalFavoriteLocations && alphabeticalFavoriteLocations.length ? alphabeticalFavoriteLocations.map(function(location) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* LocationCard */.b, {
                            location: location,
                            /** @TODO fix null callback. */ // @ts-ignore
                            setActiveLocation: null,
                            favorites: true,
                            editFavoriteLocation: true
                        }, location.id);
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteCard_styles/* StyledNoDataContainer */.RE, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(favoriteCard_styles/* StyledNoDataContent */.vV, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedStaticHeartIcon */.VF, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    tag: "h3",
                                    accessor: "favorites.locations_empty_state_header",
                                    html: true
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                    tag: "p",
                                    accessor: "favorites.locations_empty_state_subheader",
                                    html: true
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(64297);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(58408);
// EXTERNAL MODULE: ./src/components/account/favorites/favoriteOrder/index.tsx
var favoriteOrder = __webpack_require__(10676);
// EXTERNAL MODULE: ./src/components/genericErrorBoundary/index.tsx
var genericErrorBoundary = __webpack_require__(11995);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var basket_actions = __webpack_require__(29682);
;// CONCATENATED MODULE: ./src/components/account/favorites/favoriteOrders/index.tsx















var FavoriteOrders = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(FavoriteOrders, Component);
    var _super = (0,_create_super/* default */.Z)(FavoriteOrders);
    function FavoriteOrders() {
        (0,_class_call_check/* default */.Z)(this, FavoriteOrders);
        return _super.apply(this, arguments);
    }
    var _proto = FavoriteOrders.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.props.fetchMeFavoriteOrders();
    };
    _proto.render = function render() {
        var handleReorder = function handleReorder(orderDetails) {
            fetchMeOrderDetailsSuccess(orderDetails);
            reorderBasket(orderDetails, "Favorites", true);
        };
        var _props = this.props, meFavoriteOrders = _props.meFavoriteOrders, reorderBasket = _props.reorderBasket, fetchMeOrderDetailsSuccess = _props.fetchMeOrderDetailsSuccess, reorderBasketId = _props.reorderBasketId;
        if (!meFavoriteOrders.length) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLoyaltyContainer */.t9, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(favoriteCard_styles/* StyledFavoritesFlexContainer */.wo, {
                    className: cssClassNames/* CSS_CLASSES.LOYALTY.PAGE_HEADER */.Y.LOYALTY.PAGE_HEADER,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                            tag: "h2",
                            accessor: "favorites.orders_header",
                            html: true
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteCard_styles/* StyledNoDataContainer */.RE, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(favoriteCard_styles/* StyledNoDataContent */.vV, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(uielements/* ConnectedStaticHeartIcon */.VF, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        tag: "h3",
                                        accessor: "favorites.orders_empty_state_header",
                                        html: true
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                                        tag: "p",
                                        accessor: "favorites.orders_empty_state_subheader",
                                        html: true
                                    })
                                ]
                            })
                        })
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(styles/* StyledLoyaltyContainer */.t9, {
            className: cssClassNames/* CSS_CLASSES.LOYALTY.PAGE_HEADER */.Y.LOYALTY.PAGE_HEADER,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(favoriteCard_styles/* StyledFavoritesFlexContainer */.wo, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(stringAccessor/* default */.Z, {
                        tag: "h2",
                        accessor: "favorites.orders_header",
                        html: true
                    }),
                    meFavoriteOrders.map(function(order, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(genericErrorBoundary/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteOrder/* FavoriteOrderCard */.q, {
                                showSubtotal: true,
                                order: order,
                                index: index,
                                reorderBasketId: reorderBasketId,
                                reorderBasket: handleReorder,
                                eventDetail: "Favorites"
                            })
                        }, index);
                    })
                ]
            })
        });
    };
    return FavoriteOrders;
}(react.Component);
var mapStateToProps = function(state) {
    return {
        meFavoriteOrders: state.app.me.favoriteOrders,
        reorderBasketId: state.app.basket.reorderBasketId
    };
};
var mapDispatchToProps = {
    fetchMeFavoriteOrders: actions/* default.fetchMeFavoriteOrders */.Z.fetchMeFavoriteOrders,
    fetchMeOrderDetailsSuccess: actions/* default.fetchMeOrderDetailsSuccess */.Z.fetchMeOrderDetailsSuccess,
    reorderBasket: basket_actions/* default.reorderBasket */.Z.reorderBasket
};
var connector = (0,es.connect)(mapStateToProps, mapDispatchToProps);
/* harmony default export */ var favoriteOrders = (connector(FavoriteOrders));

// EXTERNAL MODULE: ./src/components/app/layout/index.tsx + 110 modules
var layout = __webpack_require__(37356);
// EXTERNAL MODULE: ./src/components/restrict/index.tsx
var restrict = __webpack_require__(40129);
;// CONCATENATED MODULE: ./pages/account/favorites/index.tsx





function FavoritesPage() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(restrict/* RestrictedAccountRoute */.Q, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
            backgroundOverride: true,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(favoriteOrders, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FavoriteLocations, {})
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [513,372,295,974,588,356,594,221,774,888,179], function() { return __webpack_exec__(29689); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);